import React from 'react'

import { CourtCaseState } from '@app/graphql/types'
import { useIntl } from '@app/intl/Intl'
import { Chip, ChipProps } from '@app/lib/display/Chip/Chip'
import { CourtCaseFragment } from '@app/queries/CourtCases/CourtCase.queries'

export type CourtCaseStateChipProps = {
  item: Pick<CourtCaseFragment, 'state'>
  size?: ChipProps['size']
}

const courtCaseStateColor: Partial<Record<CourtCaseState, ChipProps['color']>> = {
  [CourtCaseState.ClientFileCreated]: 'warning',
  [CourtCaseState.ClientFileUpdated]: 'warning',
  [CourtCaseState.ClientFileRejected]: 'info',
  [CourtCaseState.ServiceRequested]: 'info',
  [CourtCaseState.CoveragePending]: 'info',
  [CourtCaseState.Approved]: 'success',
  [CourtCaseState.Settled]: 'success',
  [CourtCaseState.Rejected]: 'danger'
}

export const CourtCaseStateChip = ({ item, size = 'sm' }: CourtCaseStateChipProps) => {
  const { formatMessage } = useIntl()

  return (
    <Chip color={courtCaseStateColor[item.state] ?? 'neutral'} size={size}>
      {formatMessage({ id: `CourtCases.State.${item.state}` })}
    </Chip>
  )
}
